<div class="row m-widget1" [formGroup]="group">
	<div class="col-xl-12" formGroupName="educationAndWorkDetails">
		<!-- <div formArrayName="tempEducationDetails" class="m-form__section m-form__section--first m-widget1__item" *ngFor="let education of group.get('educationAndWorkDetails').get('education')['controls']; let i=index"> -->
		<div class="m-form__heading">
			<h4 class="m-form__heading-title">
				Education Details:
			</h4>
		</div>
		<div class="clearfix" formArrayName="educationalDetails" *ngFor="let educationalDetails of group.get('educationAndWorkDetails').get('educationalDetails')['controls']; let i=index">
			<div [formGroupName]="i">
				<div class="row padding-10">
					<div class="form-group m-form__group col-6">
						<div class="row">
							<label class="col-form-label col-lg-4 col-sm-12">
								Education :
								<span class="red">*</span>
							</label>
							<div class="col-lg-8 col-md-8 col-sm-12">
								<select class="form-control m-bootstrap-select m_selectpicker no-opacity" formControlName="education" (change)="setEducation(group.get('educationAndWorkDetails').get('educationalDetails').controls[i],i)"
								 title="Select the Type of Education Attained">
									<option value="" disabled selected>Select Education</option>
									<option *ngFor="let educationOption of educationOptions" [ngValue]="educationOption.eduQualDesc">
										{{educationOption.eduQualDesc}}
									</option>
								</select>
								<app-form-control-messages [control]="group.get('educationAndWorkDetails').get('educationalDetails').controls[i].get('education')"
								 [name]="'Education'"></app-form-control-messages>
							</div>
						</div>
					</div>
					<div class="form-group m-form__group col-6 padding-0">
						<div class="row" *ngIf="group.get('educationAndWorkDetails').get('educationalDetails').controls[i].get('education').value!='Uneducated'">
							<label class="col-xl-4 col-lg-4 col-form-label">
								Enter Specialization:
								<span class="red">*</span>
							</label>
							<div class="col-xl-8 col-lg-8">
								<input type="text" class="form-control m-input" formControlName="specialization" maxlength="50" placeholder="Enter Specialization">
								<app-form-control-messages [control]="group.get('educationAndWorkDetails').get('educationalDetails').controls[i].get('specialization')"
								 [name]="'Specialization'"></app-form-control-messages>
							</div>
						</div>
					</div>
				</div>
				<div class="row padding-10">
					<div class="form-group m-form__group col-6">
						<div class="row" *ngIf="group.get('educationAndWorkDetails').get('educationalDetails').controls[i].get('education').value!='Uneducated'">
							<label class="col-form-label col-lg-4 col-sm-12">
								Year of Passing:
								<span class="red">*</span>
							</label>
							<div class="col-lg-8 col-md-8 col-sm-12">
								<select class="form-control m-bootstrap-select m_selectpicker no-opacity" formControlName="passingYear" placeholder="Year of Passing"
								 title="Select the Type of Education Attained">
									<option value="" disabled selected>Select the Year of Passing</option>
									<option *ngFor="let yearOption of yearsOptions" [ngValue]="yearOption">
										{{yearOption}}
									</option>
								</select>
								<app-form-control-messages [control]="group.get('educationAndWorkDetails').get('educationalDetails').controls[i].get('passingYear')"
								 [name]="'Year of Passing'"></app-form-control-messages>
							</div>
						</div>
					</div>
					<div class="form-group m-form__group col-6 padding-0" *ngIf="group.get('educationAndWorkDetails').get('educationalDetails').controls[i].get('education').value!='Uneducated'">
						<label class="col-xl-4 col-lg-4 col-form-label">
							Upload Supporting Documents:
							<span class="red">*</span>
						</label>
						<div class="col-xl-8 col-lg-8 pull-right">
							<div style="max-width: 19em;margin-left: 4px;">
								<app-upload-file [formValue]="group.get('educationAndWorkDetails').get('educationalDetails').controls[i].get('document')"
								 fileType="educationDocument" [value]="group.get('educationAndWorkDetails').get('educationalDetails').controls[i].get('document').value"
								 [(localFile)]="localFileName.document" [(localFileValue)]="localFileName.documentValue" info="only jpg, png, jpeg, pdf"></app-upload-file>
							<app-form-control-messages [control]="group.get('educationAndWorkDetails').get('educationalDetails').controls[i].get('document')"
								 [name]="'Supporting Document'"></app-form-control-messages>
								 <input type="hidden" formControlName="document" #fileInput>
							</div>
						</div>
					</div>

				</div>
				<div class="row padding-0 pull-right">
					<div class="col-xl-12 col-lg-12">
						<button class="btn btn-secondary blue-outline-btn" type="button" (click)="deleteEducationDetail(i)" *ngIf="$last||group.get('educationAndWorkDetails').get('educationalDetails').controls.length > 1">Remove</button>&nbsp; &nbsp;
						<button class="btn btn-secondary blue-outline-btn" type="button" (click)="addEducationDetails(i+1)" *ngIf="$last||group.get('educationAndWorkDetails').get('educationalDetails').controls.length == i+1&&group.get('educationAndWorkDetails').get('educationalDetails').controls[i].get('education').value!='Uneducated'">Add Education Details</button>
					</div>
				</div>

			</div>
